module.exports = __webpack_public_path__ + "static/media/opened-mail.54f77d1d.svg";